// frontend/src/utils/fuzzy.js
//
// 2026-10-21 (Stats page, per Gilles) — one small fuzzy matcher for the
// stats search bar: "dal" finds "#44 AJ Daley", "brant oct" finds the
// October Brantford game. No dependency; scoring favours word starts and
// consecutive runs, and every space-separated term must match somewhere.
//
//   fuzzyScore('dal', 'AJ Daley')  -> positive (match)
//   fuzzyScore('xyz', 'AJ Daley')  -> -1       (no match)

const scoreOne = (term, text) => {
  const t = text.toLowerCase();
  const q = term.toLowerCase();
  if (!q) return 0;
  const direct = t.indexOf(q);
  if (direct >= 0) {
    // whole-term hit: best when it starts a word
    const atWordStart = direct === 0 || /[\s#.\-–]/.test(t[direct - 1]);
    return 100 + (atWordStart ? 40 : 0) - direct;
  }
  // subsequence: every char in order, runs and word starts score higher
  let ti = 0; let score = 0; let run = 0;
  for (const ch of q) {
    const found = t.indexOf(ch, ti);
    if (found < 0) return -1;
    const atWordStart = found === 0 || /[\s#.\-–]/.test(t[found - 1]);
    run = found === ti ? run + 1 : 1;
    score += 1 + run * 2 + (atWordStart ? 6 : 0);
    ti = found + 1;
  }
  return score;
};

/** Score `query` against the given fields; -1 = no match. */
export function fuzzyScore(query, ...fields) {
  const terms = String(query || '').trim().split(/\s+/).filter(Boolean);
  if (!terms.length) return 0;
  const text = fields.filter(Boolean).join(' ');
  let total = 0;
  for (const term of terms) {
    const s = scoreOne(term, text);
    if (s < 0) return -1;             // every term must land
    total += s;
  }
  return total;
}

/** Filter + rank a list by fuzzy match. `fieldsOf(item)` -> array of strings. */
export function fuzzyFilter(query, items, fieldsOf) {
  if (!String(query || '').trim()) return items;
  return items
    .map(item => ({ item, s: fuzzyScore(query, ...fieldsOf(item)) }))
    .filter(x => x.s >= 0)
    .sort((a, b) => b.s - a.s)
    .map(x => x.item);
}
